const { STORAGE_KEYS, getSessionKeyStorageKey } = require("./secureConfig");

const DB_NAME = "secureMessagingDB";
const DB_VERSION = 1;
const STORE_KEYS = "secureKeys";

function openDB() {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open(DB_NAME, DB_VERSION);

    request.onupgradeneeded = () => {
      const db = request.result;
      if (!db.objectStoreNames.contains(STORE_KEYS)) {
        db.createObjectStore(STORE_KEYS);
      }
    };
    request.onsuccess = () => resolve(request.result);
    request.onerror = () => reject(request.error);
  });
}

async function idbGet(key) {
  const db = await openDB();
  return new Promise((resolve, reject) => {
    const tx = db.transaction(STORE_KEYS, "readonly");
    const store = tx.objectStore(STORE_KEYS);
    const req = store.get(key);
    req.onsuccess = () => resolve(req.result || null);
    req.onerror = () => reject(req.error);
  });
}

async function idbSet(key, value) {
  const db = await openDB();
  return new Promise((resolve, reject) => {
    const tx = db.transaction(STORE_KEYS, "readwrite");
    const store = tx.objectStore(STORE_KEYS);
    const req = store.put(value, key);
    req.onsuccess = () => resolve(true);
    req.onerror = () => reject(req.error);
  });
}

async function idbDelete(key) {
  const db = await openDB();
  return new Promise((resolve, reject) => {
    const tx = db.transaction(STORE_KEYS, "readwrite");
    const store = tx.objectStore(STORE_KEYS);
    const req = store.delete(key);
    req.onsuccess = () => resolve(true);
    req.onerror = () => reject(req.error);
  });
}

async function idbClearAll() {
  const db = await openDB();
  return new Promise((resolve, reject) => {
    const tx = db.transaction(STORE_KEYS, "readwrite");
    const store = tx.objectStore(STORE_KEYS);
    const req = store.clear();
    req.onsuccess = () => resolve(true);
    req.onerror = () => reject(req.error);
  });
}

// User master key (base64)
async function getUserMasterKey() {
  return await idbGet(STORAGE_KEYS.userMasterKey);
}

async function setUserMasterKey(keyBase64) {
  return await idbSet(STORAGE_KEYS.userMasterKey, keyBase64);
}

async function deleteUserMasterKey() {
  return await idbDelete(STORAGE_KEYS.userMasterKey);
}

// Session key by chatId (base64)
async function getSessionKey(chatId) {
  const k = getSessionKeyStorageKey(chatId);
  return await idbGet(k);
}

async function setSessionKey(chatId, keyBase64) {
  const k = getSessionKeyStorageKey(chatId);
  return await idbSet(k, keyBase64);
}

async function deleteSessionKey(chatId) {
  const k = getSessionKeyStorageKey(chatId);
  return await idbDelete(k);
}

// Clear everything (on logout)
async function clearAllKeys() {
  return await idbClearAll();
}

module.exports = {
  getUserMasterKey,
  setUserMasterKey,
  deleteUserMasterKey,
  getSessionKey,
  setSessionKey,
  deleteSessionKey,
  clearAllKeys,
  // low-level helpers (optional export)
  openDB,
};
